import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { OPENING_HOURS_DAYS } from '../../types/index.js';
import OpeningHours from './OpeningHours.js';
import { deprecatedPropsToProps } from './utils.js';

var ref;
const isToday = (day)=>((ref = OPENING_HOURS_DAYS[new Date().getDay()]) !== null && ref !== void 0 ? ref : '') === day
;
const getDayName = (date)=>OPENING_HOURS_DAYS[date.getDay()]
;
const hasDeprecatedProps = (props)=>'schedule' in props
;
const OpeningHoursContainer = (props)=>{
    const _ref = hasDeprecatedProps(props) ? deprecatedPropsToProps(props) : props, { openingHours , specialOpeningHours =[] , isExpanded: initialIsExpanded = false , isExpandable =true , onExpandCallback , announcement  } = _ref, rest = swcHelpers.objectWithoutProperties(_ref, [
        "openingHours",
        "specialOpeningHours",
        "isExpanded",
        "isExpandable",
        "onExpandCallback",
        "announcement"
    ]);
    const [isExpanded, setIsExpanded] = React.useState(initialIsExpanded);
    const onExpandHandler = React.useCallback((doExpand)=>{
        setIsExpanded((current)=>typeof doExpand === 'boolean' ? doExpand : !current
        );
        if (typeof onExpandCallback === 'function') {
            onExpandCallback();
        }
    }, [
        onExpandCallback
    ]);
    const { getLabel , dateTime: { formatMidsizeDate  } ,  } = useIntl();
    const labels = React.useMemo(()=>({
            title: getLabel('locations.openingHours.title'),
            specialTitle: getLabel('locations.openingHours.specialTitle'),
            regularTitle: getLabel('locations.openingHours.regularTitle')
        })
    , [
        getLabel
    ]);
    const regular = React.useMemo(()=>Object.entries(openingHours).map(([day, items])=>{
            const isOpen = items.length > 0;
            const entries = isOpen ? items.map(({ open , close  })=>({
                    key: `${day}-${open}-${close}`,
                    value: `${open} - ${close}`
                })
            ) : [
                {
                    key: `${day}-closed`,
                    value: getLabel('locations.openingHours.closed')
                }
            ];
            return {
                label: getLabel(`locations.openingHours.days.long.${day}`),
                today: isToday(day),
                status: isOpen ? 'OPEN' : 'CLOSED',
                entries
            };
        })
    , [
        openingHours,
        getLabel
    ]);
    const special = React.useMemo(()=>(specialOpeningHours !== null && specialOpeningHours !== void 0 ? specialOpeningHours : []).map(({ openClosed , dateOpenClosed , openClosedTime  })=>{
            const date = new Date(dateOpenClosed);
            const isOpen = openClosed === 'OPEN';
            const entries = isOpen ? (openClosedTime !== null && openClosedTime !== void 0 ? openClosedTime : []).map(({ open , close  })=>({
                    key: `${dateOpenClosed}-${open}-${close}`,
                    value: `${open} - ${close}`
                })
            ) : [
                {
                    key: `${dateOpenClosed}-closed`,
                    value: getLabel('locations.openingHours.closed')
                }, 
            ];
            return {
                label: `${getLabel(`locations.openingHours.days.short.${getDayName(date)}`)}, ${formatMidsizeDate(date)}`,
                status: openClosed,
                entries
            };
        })
    , [
        specialOpeningHours,
        formatMidsizeDate,
        getLabel
    ]);
    React.useEffect(()=>setIsExpanded(initialIsExpanded)
    , [
        initialIsExpanded
    ]);
    return /*#__PURE__*/ React.createElement(OpeningHours, swcHelpers.extends({}, rest, {
        announcement: announcement,
        labels: labels,
        regular: regular,
        special: special,
        openingHours: openingHours,
        specialOpeningHours: specialOpeningHours,
        isExpanded: isExpanded,
        onExpand: isExpandable ? onExpandHandler : undefined
    }));
};

export { OpeningHoursContainer as default };
//# sourceMappingURL=OpeningHoursContainer.js.map
